import { createReducer } from '@reduxjs/toolkit';

import { setIsLoading, setPostList } from './postActions.js';

const initialState = {
  postList: [],
  isLoading: false,
};

const post = createReducer(initialState, (builder) => {
  builder.addCase(setPostList, (state, { payload: postList }) => ({ ...state, postList })).addCase(setIsLoading, (state, { payload: isLoading }) => ({ ...state, isLoading }));
});

export default post;
